/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint import/no-cycle: [1, { maxDepth: 1 }] */
import React, {
  useState,
} from 'react';

// ALL MATERIAL UI COMPONENTS
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  Backdrop,
  Modal,
  Fade,
  useMediaQuery,
} from '@material-ui/core';

// IMPORT IMAGES
// IMPORTING ICONS
import { SendAppLinkModal } from '@shared/components';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  sendAppModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '9999',
  },
  paper: {
    background: 'linear-gradient(137.62deg, #04043B 0%, #280548 61.29%);',
    boxShadow: theme.shadows[5],
    color: '#fff',
    borderRadius: '20px',
    width: '100%',
    maxWidth: '580px',
    padding: '30px',
    margin: '0 10px',
    textAlign: 'center',
    boxSizing: 'border-box',
  },
}));
function LoginFooter({ loginModalDescription }) {
  // import the custom styles from useStyles
  const classes = useStyles();

  // theme from material ui
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // send text message
  const [sendAppModalStatus, setSendAppModalStatus] = useState(false);

  const openSendAppModal = () => {
    setSendAppModalStatus(true);
  };
  const closeSendAppModal = () => {
    setSendAppModalStatus(false);
  };

  function sendApp() {
    openSendAppModal();
  }

  return (
    <>
      <Grid
        item
        xs={12}
        align='center'
        style={{
          position: 'fixed',
          top: isMobile ? 500 : 530,
          left: 60,
          right: 60,
        }}
      >
        <Grid container justifyContent='center' alignItems='center'>
          <Typography
            align='center'
            className={loginModalDescription}
            gutterBottom
            style={{
              maxWidth: 400,
              minWidth: 400,
            }}
          >
            {' '}
            Don’t have an account yet?
            {' '}
            <span onClick={() => sendApp()} className='click-here-text text-white'><u>Sign Up</u></span>
            {' '}
          </Typography>
        </Grid>
      </Grid>
      <Modal
        className={classes.sendAppModal}
        open={sendAppModalStatus}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={sendAppModalStatus}>
          <div className={classes.paper}>

            <CloseIcon className='close-icon' disableRipple onClick={closeSendAppModal} />
            <div className='sendAppInnerModal'>

              <Typography className='sendAppModalTitle'>Send Me The App</Typography>

              <SendAppLinkModal />
            </div>
          </div>
        </Fade>
      </Modal>
    </>

  );
}

export default LoginFooter;
